import { GeometryContainer, GeometryType, CompiledGeometryContainer } from "@spi/Common/Geometry";
import { Light } from "./Light/Light";
import { ConditionalGate, NavigationMesh, PathNode } from "@spi/Common/NavigationMesh";
import { BoundingBox } from "@spi/Common/Util";
import { ILogger } from "@spi/Common/Logging/Logger";

export class SceneState {
    private _navigationMesh: NavigationMesh;
    public geometryContainers: GeometryContainer[];
    public compiledGeometry: CompiledGeometryContainer[];
    public lights: Light[];
    public navigationGraph: PathNode[];
    public textureAssets: TextureAssetDescriptor[];
    public boundingBox: BoundingBox;

    constructor(public reference: string, public name: string) {
        this._navigationMesh = null;
        this.geometryContainers = [];
        this.lights = [];
        this.navigationGraph = [];
        this.compiledGeometry = [];
        this.textureAssets = [];
    }

    public getRequiredTextures(): string[] {
        return [];
    }

    public getRequiredAssets(): string[] {
        return [];
    }

    public createNavigationGraph(logger: ILogger) {
        this._navigationMesh = new NavigationMesh({
            bounds: this.boundingBox,
            segmentSize: 100,
            voxelSize: 1,
            maxConvexExpansion: 20,
            maxNeighbourStepHeight: 1,
            minTraversableHeight: 10
        }, logger);

        logger.info('Generating navigation mesh. Fresh RAM nomnomnom...');
        for (let geo of this.geometryContainers) {
            switch (geo.type) {
                case GeometryType.Uncompiled:
                case GeometryType.Generic:
                    logger.info(`Processing generic geometry: ${geo.reference}...`);
                    this._navigationMesh.addGeometry(geo.faces);
                    break;
                case GeometryType.Conditional:
                    logger.info(`Processing conditional geometry: ${geo.reference}...`);
                    let gate = new ConditionalGate();
                    gate.gateReference = geo.reference;
                    gate.faces = geo.faces;
                    this._navigationMesh.addConditionalGates([gate]);
                    break;
            }
        }

        logger.info('Generating node graph...');
        this._navigationMesh.generate();
        logger.info('Navigation mesh complete');

        this.navigationGraph = this._navigationMesh.pathNodes;
    }
}

export type TextureAssetDescriptor = {
    reference: string,
    uri: string,
    translucent: boolean
};